import { Ban, Loader2 } from "lucide-react";
import type { AudioLabProgressSnapshot } from "../../audio-lab/audioLabZip";

interface AudioLabProgressPanelProps {
  active: boolean;
  label: string;
  progress: AudioLabProgressSnapshot | null;
  onCancel: () => void;
}

export function AudioLabProgressPanel({ active, label, progress, onCancel }: AudioLabProgressPanelProps) {
  const completed = progress?.completed ?? 0;
  const total = progress?.total ?? 0;
  const percent = total > 0 ? Math.min(100, Math.round((completed / total) * 100)) : 0;

  return (
    <section className="audio-lab-progress" aria-label="Audio Lab export progress" aria-live="polite">
      <div>
        <p className="eyebrow">Export Status</p>
        <h2>{active ? label : "Ready"}</h2>
        <p>{active && progress ? `Generating ${completed} / ${total} files` : "No export is currently running."}</p>
        {progress ? <small>Current: {progress.current}</small> : null}
      </div>
      <div className="audio-lab-progress-meter" aria-hidden="true">
        <span style={{ width: `${percent}%` }} />
      </div>
      <button className="audio-lab-cancel-button" type="button" disabled={!active} onClick={onCancel}>
        {active ? <Loader2 size={17} aria-hidden="true" /> : <Ban size={17} aria-hidden="true" />}
        <span>Cancel</span>
      </button>
    </section>
  );
}
